import React, { useState } from "react";
import { Input, Button, Form, Alert, Card } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "antd/dist/reset.css";
import image from '../../assets/ust-logo.png';
import "./Login.css"; 
import Footer from "../Footer/Footer";

const ResetLogin = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loginError, setLoginError] = useState(null);
  const [loading, setLoading] = useState(false);
  const basePath = sessionStorage.getItem('APP_BASE_PATH')

  // Handle login
  const onFinish = async (values) => {
    setLoginError(null);
    setLoading(true);

    try {
      const response = await axios.post("http://localhost:8080/reset-auth/login", values, {
        headers: { "Content-Type": "application/json" }
      });

      console.log("Login Response:", response.data); // Debugging

      // ✅ Store token (if needed in future)
      localStorage.setItem("resetLoginUser", values.email);

      // ✅ Redirect to dashboard
      navigate(`${basePath}/normaluser-dashboard`);
      
    } catch (err) {
      console.error("Login Error:", err);

      // ✅ Ensure error message is a string
      setLoginError(
        err.response?.data?.message || "Login failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full login-container">
      <div className="left-section hidden lg:flex"></div>
      <div className="right-section flex justify-center items-center w-full px-6">
        <Card className="login-card w-full max-w-md">
          <div className="logo-container">
            <img src={image} alt="UST Logo" className="login-image" />
          </div>
          <h4 className="text-2xl font-semibold text-center whitespace-nowrap login-title">
            Login after Reset
          </h4>
          {loginError && <Alert message={loginError} type="error" showIcon className="mb-4" />} 
          <Form form={form} name="reset-login" initialValues={{ remember: true }} onFinish={onFinish}>
            <Form.Item name="email" rules={[{ required: true, message: "Enter Email!" }, { type: "email", message: "Enter a valid Email!" }]}>
              <Input placeholder="Email" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "Enter password!" }]}>
              <Input.Password placeholder="Password" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block className="custom-button" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
      <Footer />
    </div>
  );
};

export default ResetLogin;
